// src/components/TranscriptionPanel.tsx
import React from "react";

export default function TranscriptionPanel({
  shouldBeListening,
  onStart,
  onStop,
  onReshare,
  reshareBtnRef,
  transcript,
  transcriptTail,
  prefixControls,
}: {
  shouldBeListening: boolean;
  onStart: () => void;
  onStop: () => void;
  onReshare: () => void;
  reshareBtnRef: React.RefObject<HTMLButtonElement>;
  transcript: string;
  transcriptTail: string;
  prefixControls?: React.ReactNode;
}) {
  return (
    <div className="transcript-pane vstack-sm">
      {prefixControls}

      <div className="button-group" style={{ alignItems: "center", gap: 8 }}>
        <button
          className="button button-primary"
          onClick={onStart}
          disabled={shouldBeListening}
          aria-disabled={shouldBeListening}
          title={shouldBeListening ? "Already listening" : "Start listening"}
        >
          {shouldBeListening ? "Listening…" : "Start"}
        </button>

        <button
          className="button button-secondary"
          onClick={onStop}
          disabled={!shouldBeListening}
          aria-disabled={!shouldBeListening}
          title={shouldBeListening ? "Stop listening" : "Not listening"}
        >
          Stop
        </button>

        <span className="muted small" aria-live="polite" style={{ paddingLeft: 4 }}>
          Source: <b>System Audio</b> (required for triggers)
        </span>

        {shouldBeListening && (
          <button
            ref={reshareBtnRef}
            className="button button-secondary"
            onClick={onReshare}
            style={{ marginLeft: 6 }}
            title="Re-share system audio"
          >
            Re-share System Audio
          </button>
        )}
      </div>

      <div className="card transcript-card">
        {(transcript + (transcriptTail ? " " + transcriptTail : "")).trim() || (
          <span className="placeholder-text">Transcript will appear here...</span>
        )}
      </div>
    </div>
  );
}
